import { createAction, handleActions } from 'redux-actions';
import { Map } from 'immutable';
export const actions = {
    REQUEST: createAction('ACCOUNTS/ORGANIZATION_LOGO/REQUEST'),
    SUCCESS: createAction('ACCOUNTS/ORGANIZATION_LOGO/SUCCESS'),
    ERROR: createAction('ACCOUNTS/ORGANIZATION_LOGO/ERROR'),
    DELETE: createAction('ACCOUNTS/ORGANIZATION_LOGO/DELETE'),
};
export const initialState = Map({
    isProcessing: null,
    error: null,
    loaded: false,
    logo: null,
});
const reducer = handleActions({
    [actions.REQUEST]: (state) => state.set('isProcessing', true).set('error', false),
    [actions.SUCCESS]: (state, action) => state
        .set('logo', action.payload)
        .set('isProcessing', false)
        .set('error', false)
        .set('loaded', true),
    [actions.ERROR]: (state) => state.set('isProcessing', false).set('error', true).set('loaded', true),
}, initialState);
export default reducer;
